let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9m1m1")).then(() => parcelRequire('fO125'));